import React, {Component} from 'react'
import {DPart} from '../../store/model';

interface props {
    state: DPart[]
    dimension: { height: number, width: number }
}

class ClusterLine extends Component<props> {

    async componentDidMount() {
    }

    render() {
        const D = this.props.state;
        const {height, width} = this.props.dimension;
        const top = height * 0.03, bottom = height * 0.85;
        const scale = width / 2105;
        return (
            <>
                {D.map((dataItem: DPart, index: number) => (
                    <line
                        key={index}
                        x1={dataItem.cx * scale + ""}
                        y1={top + ""}
                        x2={dataItem.cx * scale + ""}
                        y2={bottom + ""}
                        stroke={dataItem.color}
                        strokeWidth={scale * 4 + "px"}/>
                ))}
                {D.map((dataItem: DPart, index: number) => (
                    <text
                        key={index}
                        style={
                            {
                                fontSize: 20 * scale,
                                fontWeight: 750 * scale,
                                fontFamily: 'Monaco',
                            }
                        }
                        x={dataItem.cx * scale - 5 * dataItem.text.length * scale}
                        y={scale * 1010}
                        fill={dataItem.color}
                    >{dataItem.text}</text>
                ))}
            </>
        )
    }
}

export default ClusterLine;